module.exports = __webpack_public_path__ + "img/5d41632512ef9.9f99cac5.png";